import * as pc from 'playcanvas';

const placeholders = new WeakMap<pc.GraphicsDevice, pc.Texture>();

/**
 * A 1x1 RG8 texture standing for "no cloud", bound to the cloud-shadow slots of the splat
 * receiving shader whenever no cloud layer fills them (both backends reject a draw with nothing
 * bound to a declared sampler). R = 0 optical depth, G = 1 (rank: never covered).
 */
export function getCloudShadowPlaceholder(device: pc.GraphicsDevice): pc.Texture {
    let texture = placeholders.get(device);
    if (!texture) {
        texture = new pc.Texture(device, {
            name: 'CloudShadowPlaceholder',
            width: 1,
            height: 1,
            format: pc.PIXELFORMAT_RG8,
            mipmaps: false,
            minFilter: pc.FILTER_NEAREST,
            magFilter: pc.FILTER_NEAREST,
            levels: [new Uint8Array([0, 255])],
        });
        placeholders.set(device, texture);
    }
    return texture;
}
